import { render } from "./allusers.vue?vue&type=template&id=628c3402"
import script from "./allusers.vue?vue&type=script&lang=js"
export * from "./allusers.vue?vue&type=script&lang=js"

import "./allusers.vue?vue&type=style&index=0&id=628c3402&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__